export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: "Div",
              attributes: { class: 'row-support' },
              components: [      
                {
                  type:'itemLegalSupport',
                },
                {
                  type:'itemLegalSupport',
                },
                {
                  type:'itemLegalSupport',
                },
              ],
              styles: `
              .row-support{
                display:flex;
                gap: 20px;
              }
              @media (max-width:992px){
                .row-support{
                  flex-direction:column;
                  gap: 20px;
                }
              }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};